import { useEffect } from "react";
import { Layout } from "@/components/layout";
import { SEOHead } from "@/components/seo";

const Terms = () => {
  useEffect(() => {
    document.title = "Terms of Service | Prime Realty Partners - New Jersey Real Estate";
  }, []);

  return (
    <Layout>
      <SEOHead
        title="Terms of Service"
        description="Read Prime Realty Partners' terms of service. Understand your rights and responsibilities when using our website and real estate services."
        canonicalUrl="https://www.prpsj.com/terms"
        breadcrumbs={[{ name: "Home", url: "https://www.prpsj.com" }, { name: "Terms of Service", url: "https://www.prpsj.com/terms" }]}
      />

      <div className="container py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-4">
            Terms of Service
          </h1>
          <p className="text-muted-foreground mb-8">
            Last updated: January 1, 2026
          </p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Acceptance of Terms
              </h2>
              <p className="text-muted-foreground">
                By accessing or using the Prime Realty Partners website and services, you agree to be 
                bound by these Terms of Service. If you do not agree to these terms, please do not 
                use our services.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Description of Services
              </h2>
              <p className="text-muted-foreground">
                Prime Realty Partners provides an online platform for browsing real estate listings, 
                connecting with licensed real estate agents, scheduling property showings, and 
                accessing real estate market information. Our services are intended for informational 
                purposes and to facilitate connections between consumers and real estate professionals.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                User Responsibilities
              </h2>
              <p className="text-muted-foreground mb-4">
                When using our services, you agree to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Use the services only for lawful purposes</li>
                <li>Not interfere with or disrupt the services</li>
                <li>Not attempt to gain unauthorized access to any part of the services</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Property Information
              </h2>
              <p className="text-muted-foreground">
                Property listings and related information are provided for informational purposes only. 
                While we strive to ensure accuracy, we do not guarantee the completeness or accuracy 
                of any listing information. All property information should be independently verified 
                before making any real estate decisions.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Intellectual Property
              </h2>
              <p className="text-muted-foreground">
                All content on this website, including text, graphics, logos, images, and software, 
                is the property of Prime Realty Partners or its content suppliers and is protected 
                by copyright and other intellectual property laws. You may not reproduce, distribute, 
                or create derivative works from this content without our express written permission.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Disclaimer of Warranties
              </h2>
              <p className="text-muted-foreground">
                THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, 
                EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, 
                ERROR-FREE, OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Limitation of Liability
              </h2>
              <p className="text-muted-foreground">
                TO THE FULLEST EXTENT PERMITTED BY LAW, PRIME REALTY PARTNERS SHALL NOT BE LIABLE 
                FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING 
                OUT OF OR RELATED TO YOUR USE OF THE SERVICES.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Governing Law
              </h2>
              <p className="text-muted-foreground">
                These Terms shall be governed by and construed in accordance with the laws of the 
                State of California, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Changes to Terms
              </h2>
              <p className="text-muted-foreground">
                We reserve the right to modify these Terms at any time. We will notify users of 
                material changes by posting the updated terms on this page with a new "Last updated" 
                date. Your continued use of the services after such changes constitutes acceptance 
                of the new terms.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold mb-4">
                Contact Us
              </h2>
              <p className="text-muted-foreground">
                If you have questions about these Terms of Service, please contact us at:
              </p>
              <div className="mt-4 text-muted-foreground">
                <p>Prime Realty Partners</p>
                <p>31 Walnut Ave</p>
                <p>Bellmawr, NJ 08031</p>
                <p>Email: info@prpsj.com</p>
                <p>Phone: (856) 210-3000</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
